module.exports = __webpack_public_path__ + "img/3.b17be982.png";